import { setImmediate as setImmediatePromise } from "node:timers/promises";
/**
 * Runs queued tasks one per event loop iteration, in the order they were
 * pushed. While the queue is idle, a task runs synchronously inside `push`.
 */
export class EventQueue {
    onError;
    tasks = [];
    draining = false;
    constructor(onError) {
        this.onError = onError;
    }
    push(task) {
        this.tasks.push(task);
        if (!this.draining)
            void this.drain();
    }
    clear() {
        this.tasks = [];
    }
    async drain() {
        this.draining = true;
        try {
            let task;
            while ((task = this.tasks.shift())) {
                try {
                    task();
                }
                catch (e) {
                    this.onError(e instanceof Error ? e : new Error(`${e}`));
                }
                // The last task must yield too, so `draining` stays true for the rest
                // of this tick
                await setImmediatePromise();
            }
        }
        finally {
            this.draining = false;
        }
    }
}
